import { render, staticRenderFns } from "./CompanyRank.vue?vue&type=template&id=35b6a100&scoped=true&"
import script from "./CompanyRank.vue?vue&type=script&lang=js&"
export * from "./CompanyRank.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRank.vue?vue&type=style&index=0&id=35b6a100&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b6a100",
  null
  
)

export default component.exports